<template>
  <a
    v-if="url"
    :href="url"
    target="_blank"
  >
    {{ label }}
  </a>
  <span v-else>
    {{ label }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

/**
 * @typedef {Object} FlaggableCellParams
 * @property {Object} data
 */
const props = defineProps({
  /** @type {FlaggableCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const url = computed(() => {
  return props.params.data.flaggable?.url
})
const label = computed(() => {
  return props.params.data.flaggable ? props.params.data.flaggable.type + ' - ' + props.params.data.flaggable.name : '-'
})
</script>
